import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import Selector from 'modules/employees/components/Selector'
import { Level } from 'modules/employees/hooks/useLegalEntityRoles'

interface Props {
  onLevelSelect: (value: string | undefined) => void
  selectedLevel: string | undefined
  levels: Level[]
  disabled?: boolean
  isOpen?: boolean
  mandatory?: boolean
  onToggle?: (isOpen: boolean) => void
  noLevels?: boolean
  createLevel: (value: string) => void
  error?: string
  canCreate?: boolean
}

const levelsOptions = (levels: Level[]) => {
  return levels
    .filter((x) => !x.isDefault)
    .map((level: Level) => {
      const { id, name } = level

      return (
        <Selector.Option key={id} value={id} label={name} searchValue={name}>
          {name}
        </Selector.Option>
      )
    })
}

const noLevelsOption = (levels: Level[]) => {
  levels = levels.filter((x) => !x.isDefault)

  return levels.map((level: Level) => {
    const { id } = level

    return (
      <Selector.Option
        key={id}
        value={id}
        label={i18n.t('employee_form.wizard.role_step.level_selector.no_levels_option.label')}
        searchValue={i18n.t('employee_form.wizard.role_step.level_selector.no_levels_option.label')}
      >
        {i18n.t('employee_form.wizard.role_step.level_selector.no_levels_option.label')}
      </Selector.Option>
    )
  })
}

const LevelSelect = ({
  onLevelSelect,
  selectedLevel,
  levels,
  disabled,
  isOpen,
  onToggle,
  noLevels,
  createLevel,
  mandatory = false,
  error,
  canCreate = true,
}: Props) => {
  const placeholder = noLevels
    ? i18n.t('employee_form.wizard.role_step.level_selector.placeholder2')
    : i18n.t('employee_form.wizard.role_step.level_selector.placeholder')

  return (
    <Selector.Popover
      label={i18n.t('employee_form.wizard.role_step.level_selector.label')}
      value={selectedLevel ? [selectedLevel] : []}
      onChange={(level) => onLevelSelect(level ? `${level}` : undefined)}
      placeholder={placeholder}
      isDisabled={disabled}
      isOpen={isOpen}
      blankAction={createLevel}
      actionLabel={i18n.t('employee_form.wizard.role_step.role_selector.action_label')}
      onToggle={onToggle}
      mandatory={mandatory}
      error={error}
      canCreate={canCreate}
    >
      {noLevels ? noLevelsOption(levels) : levelsOptions(levels)}
    </Selector.Popover>
  )
}

export default LevelSelect
